<div class="product-silo" data-test="product-silo">
  <ng-container *ngIf="locationSilos$ | async as silos">
    <div class="product-silo__content" *ngIf="silos?.length > 0">
      <div class="flex--row flex--align-center spacing--margin-half-top">
        <div class="flex__child">
          <div class="text--label">{{ 'product.wizard.silo.amount' | translate }}</div>
          <div *ngIf="orderingInformation">
            <ng-container>
              {{ quantity }}
            </ng-container>
            {{ 'unit.' + orderingInformation?.orderUnit | translate }}
          </div>
        </div>
      </div>

      <div>
        <div class="border-top spacing--margin-top">
          <mat-card appearance="outlined" class="spacing--margin-vertical spacing--margin-half-horizontal mat-elevation-z1">
            <mat-card-header>
              <p class="text--bold spacing--margin-none-top spacing--margin-half-bottom">
                {{ 'product.wizard.silo.choose-silo' | translate }}
              </p>
            </mat-card-header>

            <mat-card-content>
              <div [class]="(isLtSm$ | async) ? 'flex--column' : 'flex--row flex--gutter flex--align-center'" [formGroup]="group">
                <!-- Full (Selected Silo) -->
                <mat-form-field appearance="outline" class="product-silo__card-input mat-form-field__no-spacing flex__child">
                  <mat-label>{{ 'product.wizard.silo.full' | translate }}</mat-label>
                  <mat-select multiple formControlName="full" data-test="productlist__silo-full" [(ngModel)]="selectedSilos">
                    <ng-container *ngIf="locationSilos$ | async as locationSilos; else noFullSilosAvailable">
                      <mat-option *ngFor="let silo of locationSilos" [disabled]="silo.id === selectedSiloId" [value]="silo">
                        {{ silo | formatSiloTitle }}
                      </mat-option>
                    </ng-container>

                    <ng-template #noFullSilosAvailable>
                      <mat-option>
                        {{ 'product.wizard.silo.no-silos-available' | translate }}
                      </mat-option>
                    </ng-template>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    class="product-silo__loading flex--row flex--justify-center flex--align-center spacing--margin-vertical"
    data-test="product-silo__loading"
    *ngIf="(silosLoaded$ | async) !== true && (silosNotAvailable$ | async) !== true"
  >
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ng-container *ngIf="(silosNotAvailable$ | async) === true">
    <div class="product-silo__warning notification notification-warning text--input-small" data-test="product-silo__no-silos-warning">
      <mat-icon>warning</mat-icon>
      {{ 'product.wizard.silo.error-no-silos' | translate }}
    </div>
  </ng-container>
</div>
